import { render, staticRenderFns } from "./UploadVoucher.vue?vue&type=template&id=cbd89456&scoped=true"
import script from "./UploadVoucher.vue?vue&type=script&lang=js"
export * from "./UploadVoucher.vue?vue&type=script&lang=js"
import style0 from "./UploadVoucher.vue?vue&type=style&index=0&id=cbd89456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd89456",
  null
  
)

export default component.exports